interface State {
  LoadNoticesList: any[];
  LoadNoticesCount: number;
  ProductPrefixesList: any[];
  ProductThicknessList: string[];
  ProductComponentTypeList: any[];
  ProductComponentTypeCount: number;
}

const initialState: State = {
  LoadNoticesList: [],
  LoadNoticesCount: 0,
  ProductPrefixesList: [],
  ProductThicknessList: [],
  ProductComponentTypeList: [],
  ProductComponentTypeCount: 0,
};

export const loadNoticeReducer = (
  state: State = initialState,
  action: any,
): State => {
  switch (action.type) {
    case "GET_LOAD_NOTICES_DATA":
      return {
        ...state,
        LoadNoticesList:
          action.payload.page === 1
            ? action.payload.data
            : [...state.LoadNoticesList, ...action.payload.data],
        LoadNoticesCount: action.payload.count,
      };

    case "GET_PRODUCT_PREFIXES_DATA":
      return {
        ...state,
        ProductPrefixesList: action.payload,
      };

    case "GET_PRODUCT_THICKNESS_DATA":
      return {
        ...state,
        ProductThicknessList: action.payload,
      };

    case "GET_PRODUCT_COMPONENT_TYPES_DATA":
      return {
        ...state,
        ProductComponentTypeList:
          action.payload.page === 1
            ? action.payload.data
            : [...state.ProductComponentTypeList, ...action.payload.data],
        ProductComponentTypeCount: action.payload.count,
      };

    case "CLEAR_LOAD_NOTICE_DATA":
      return {
        ...state,
        LoadNoticesList: [],
        LoadNoticesCount: 0,
        ProductPrefixesList: [],
        ProductThicknessList: [],
        ProductComponentTypeList: [],
        ProductComponentTypeCount: 0,
      };

    default:
      return state;
  }
};
